import {Box, Card, CardContent, Typography} from "@mui/material";
import AuthFormFooter from "auth/Form/AuthFormFooter";
import LoginForm from "auth/Form/LoginForm";
import ResetForm from "auth/Form/ResetForm";
import SignUpForm from "auth/Form/SignUpForm";
import {AUTH_MODES, type AuthMode} from "auth/types";
import {type FC, useState} from "react";

const AuthForm: FC<{initialMode?: AuthMode}> = ({
  initialMode = AUTH_MODES.LOGIN,
}) => {
  const [mode, setMode] = useState<AuthMode>(initialMode);

  const titles = {
    [AUTH_MODES.LOGIN]: "Sign In",
    [AUTH_MODES.SIGNUP]: "Create Account",
    [AUTH_MODES.RESET]: "Reset Password",
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      px={2}>
      <Card elevation={0}>
        <CardContent>
          <Typography variant="h5" align="center" gutterBottom>
            {titles[mode]}
          </Typography>

          {mode === AUTH_MODES.LOGIN && <LoginForm />}
          {mode === AUTH_MODES.SIGNUP && <SignUpForm />}
          {mode === AUTH_MODES.RESET && <ResetForm onSwitch={setMode} />}

          <AuthFormFooter mode={mode} onSwitch={setMode} />
        </CardContent>
      </Card>
    </Box>
  );
};
export default AuthForm;
